import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=8cf4c774&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf4c774')) {
      api.createRecord('8cf4c774', component.options)
    } else {
      api.reload('8cf4c774', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=8cf4c774&", function () {
      api.rerender('8cf4c774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schools/Create.vue"
export default component.exports